import createIcon from '../../createIcon';

/**
 * @component @name KeyboardReturn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSA3VjExSDYuMzNMOS45MSA3LjQxTDguNSA2TDIuNSAxMkw4LjUgMThMOS45MSAxNi41OUw2LjMzIDEzSDIxLjVWN0gxOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardReturn = createIcon('KeyboardReturn', [
  [
    'path',
    {
      d: 'M19.5 7V11H6.33L9.91 7.41L8.5 6L2.5 12L8.5 18L9.91 16.59L6.33 13H21.5V7H19.5Z',
      key: 'pilwjx',
    },
  ],
]);

export default KeyboardReturn;
